import { Expose } from 'class-transformer'
import { Entity } from '@/app/common/base/entity'

export class MyUploadedDocument extends Entity<MyUploadedDocument> {
    @Expose()
    id!: string

    @Expose({ name: 'filename' })
    name!: string

    @Expose()
    description?: string | null

    @Expose()
    remarks?: string | null

    @Expose({ name: 'created_at' })
    uploadedAt!: string

    @Expose({ name: 'document_type' })
    documentType?: string | null

    @Expose({ name: 'is_deletable' })
    isDeletable?: boolean

    @Expose({ name: 'status_code' })
    statusCode?: string | null

    @Expose({ name: 'status_label' })
    statusLabel?: string | null
}
